export const IconResources = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" id="resources-icon" width="25" height="25" viewBox="0 0 25 25">
      <circle id="Ellipse_933" data-name="Ellipse 933" cx="12.5" cy="12.5" r="12.5" fill="#060703"/>
      <g id="Icon_feather-book" data-name="Icon feather-book" transform="translate(2 3)">
        <path id="Path_44653" data-name="Path 44653" d="M6,27.057A1.557,1.557,0,0,1,7.557,25.5h8.407" transform="translate(0 -13.159)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
        <path id="Path_44654" data-name="Path 44654" d="M7.557,3h8.407V15.455H7.557A1.557,1.557,0,0,1,6,13.9V4.557A1.557,1.557,0,0,1,7.557,3Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      </g>
    </svg>
  )
};